export const mutations = {
    writeLoginData(state, data) {
        state.widgetId = data.widget_id;
        state.chief = data.chief;
        state.login = data.login;
        state.bonuses = data.bonuses;
        state.isFree = 1;
        state.isBusiness = data.isBusiness;
        state.isCheck = data.isCheck;
        state.licenseAgreement = data.license_agreement;
        state.isPartnerCalc = data.widget_setting.partner_calc;
        state.settings = {
            hideAdditionalParams: !!data.settings.hide_additional_params,
            hideBaseContacts: !!data.settings.hide_base_contacts,
            hideSelectedPrograms: !!data.settings.hide_selected_programs,
            hideChecks: !!data.settings.hide_checks,
            hideDigest: !!data.settings.hide_digest,
            hideFirstStage: !!data.settings.hide_first_stage,
            hideSecondStage: !!data.settings.hide_second_stage,
            hideThirdStage: !!data.settings.hide_third_stage,
            showInsurance: !!data.settings.show_insurance,
            showAboutBanks: !!data.settings.show_about_banks,
        };
        state.widgetSetting = {
            logo: data.widget_setting.logo,
            colors: data.widget_setting.colors,
            partnerCalcConditions: data.widget_setting.partner_calc_conditions.map(condition => {
                return { title: condition.Title, url: condition.Url };
            }),
        };
    },
    getUserTokenFromLocalStorage(state) {
        state.userToken = localStorage.getItem("User-token") || undefined;
    },
    writeUserToken(state, token) {
        state.userToken = token;
        localStorage.setItem("User-token", token);
    },
    deleteUserToken(state) {
        state.userToken = undefined;
        localStorage.removeItem("User-token");
    },
    writeParticipantList(state, data) {
        state.participants = data ?? [];
    },
    addParticipant(state, data) {
        state.participants = [...state.participants, data];
    },
    editParticipant(state, data) {
        const index = state.participants.findIndex((participant) => participant.id === data.id);
        state.participants[index].id = data.id;
        state.participants[index].login = data.login;
    },
    deleteParticipant(state, id) {
        const index = state.participants.findIndex((participant) => participant.id === id);
        state.participants.splice(index, 1);
    },
    toggleLicenseAgreement(state, bool) {
        state.licenseAgreement = bool;
    },
};
